import React, { useEffect } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import axios from "axios";
import { jwtDecode } from "jwt-decode";
import { createTheme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import "@fontsource/inter";

import { CircularProgress } from "@mui/material";

import { AdminApiEndpoints } from "@configuration/apiEndpoints";
import { useAuthentication } from "@redux/authentication/hook";
import { useSnackbar } from "@context/snackbarContext";

import Header from "./header";
import Navbar from "./navbar";

import "./layout.css";

const theme = createTheme({
  typography: {
    fontFamily: 'Inter, Arial, sans-serif',
  },
});

export default function Layout() {
  const location = useLocation();
  const {
    user,
    isAuthenticated,
    updateUser,
    updateIsAuthenticated,
    deauthenticateUser,
    updateModuleAccess,
  } = useAuthentication();
  const openSnackbar = useSnackbar();

  var accessToken = localStorage.getItem("accessToken");

  const validateToken = async () => {
    await axios
      .post(AdminApiEndpoints.validateToken, accessToken)
      .then((res) => {
        if (res.data?.accessToken) {
          localStorage.setItem("accessToken", res.data?.accessToken);
        }
        updateUser(res.data?.user);
        updateIsAuthenticated(true);
      })
      .catch(async (error) => {
        deauthenticateUser();
        openSnackbar(
          "Oops! It seems you've been logged out due to security measures. For your safety, please log in again.",
          "error"
        );
      });
  };

  // const refreshToken = async () => {
  //   await axios
  //     .post(AdminApiEndpoints.validateToken, accessToken)
  //     .then((res) => {
  //       localStorage.setItem("accessToken", res.data?.accessToken);
  //       updateIsAuthenticated(true);
  //     })
  //     .catch((error) => {
  //       deauthenticateUser();
  //       openSnackbar(
  //         "Oops! It seems you've been logged out due to security measures. For your safety, please log in again.",
  //         "error"
  //       );
  //     });
  // };

  useEffect(() => {
    if (isAuthenticated === null) {
      if (accessToken) {
        validateToken();
      } else {
        updateIsAuthenticated(false);
      }
    }
  }, []);

  useEffect(() => {
    if (accessToken && typeof accessToken === "string" && accessToken.split(".").length === 3) {
      try {
        const decoded = jwtDecode(accessToken);
        const expiryTimestamp = decoded.exp;
  
        if (!expiryTimestamp) {
          console.error("No expiry timestamp found in token");
          return;
        }
  
        const interval = setInterval(async () => {
          const now = Math.floor(Date.now() / 1000);
          const timeUntilExpiry = expiryTimestamp - now;
          if (timeUntilExpiry <= 300) {
            await validateToken();
          }
        }, 30000);
  
        return () => clearInterval(interval);
      } catch (error) {
        console.error("Failed to decode JWT:", error);
      }
    } else {
      console.warn("Invalid or missing access token:", accessToken);
    }
  }, [accessToken]);

  useEffect(() => {
      const setModuleAccess = [
        ...new Set(
          user?.userRoles?.flatMap((userRole) =>
            userRole?.role?.roleModules
              ?.map((rm) => {
                return {
                  moduleGuid: rm?.moduleGuid,
                  grandAccess: rm?.grandAccess,
                  isAdmin: rm?.isAdmin,
                };
              })
          )
        ),
      ];
      updateModuleAccess(setModuleAccess);
  }, [user]);

  return (
    <ThemeProvider theme={theme}>
    <CssBaseline />
    {
    isAuthenticated === null ? (
      <div className="loading-container">
        <CircularProgress disableShrink />
      </div>
    ) : isAuthenticated ?  
    (
      <div className="main-container">
        <div className="header">
          <Header />
        </div>

        <div className="navbar">
          <Navbar
            isDrawer={false}
          />
        </div>

        <div className="main">
          <Outlet />
        </div>
      </div>
    ) 
    : (
      <Navigate to="/admin/login" state={{ from: location }} replace={true} />
    )
    }
    </ThemeProvider>
  )
}
